import React, { Fragment } from 'react';

import { useQuery } from '@tanstack/react-query';
import { Link } from '~/lib/react-router-dom';

import { Button, CircularProgress } from '@mui/material';
import type { ButtonProps, SxProps, Theme } from '@mui/material';

import { getPartnerships } from '~/services/LoyaltyService';

import getEarnOrderPartnerships from '~/utils/getEarnOrderPartnerships';

type Props = {
  user: App.User;
  buttonVariant?: ButtonProps['variant'];
  buttonSx?: SxProps<Theme>;
  startIcon?: React.ReactNode;
};

const loyaltyPageUri = (userId: string, code: string) => {
  return `/users/${userId}/loyalty/${code}`;
};

const PARTNERSHIP_ORDER: Record<string, number> = {
  Qantas: 0,
  'Singapore Airlines': 1,
};

export default function PartnershipButtons({ user, buttonVariant = 'contained', buttonSx, startIcon }: Props) {
  const { data: partnerships = [], isLoading } = useQuery<Array<App.Partnership>, Error>({
    queryKey: ['partnerships', 'earnOrder'],
    queryFn: async () => {
      const response = await getPartnerships();
      return getEarnOrderPartnerships(response.result).sort((a, b) => {
        return (
          (PARTNERSHIP_ORDER[a.brandName] ?? Number.MAX_SAFE_INTEGER) -
          (PARTNERSHIP_ORDER[b.brandName] ?? Number.MAX_SAFE_INTEGER)
        );
      });
    },
  });

  if (isLoading) {
    return <CircularProgress size="24px" />;
  }

  return (
    <>
      {partnerships.map((partnership: App.Partnership) => (
        <Fragment key={partnership.code}>
          <Button
            component={Link}
            className="T-view-qantas-btn"
            variant={buttonVariant}
            startIcon={startIcon}
            sx={buttonSx}
            to={loyaltyPageUri(user.id_member, partnership.code)}
          >
            {partnership.brandName}
          </Button>
        </Fragment>
      ))}
    </>
  );
}
